{
  "Início": "ui_325dfc37c9ba",
  "Portfólio": "ui_6899731dbc3f",
  "Serviços": "ui_4944b0b2b626",
  "Rede IA": "ui_73522c685797",
  "Ao Vivo": "ui_f4f7456d8037",
  "Contato": "ui_28594e2a878c",
  "Contact": "ui_2b5c3d26721a",
  "Coloque aqui seus dados de contato, formulário, redes sociais, etc.": "ui_cc35accbbbab",
  "Engenheiro de Software": "ui_09734e062d83",
  "Desenvolvedor": "ui_e5a6bcd5e6c9",
  "Dev Full Stack": "ui_68c3cfaf68fa",
  "Back-End e APIs": "ui_a9cc756f6c0e",
  "Cloud e DevOps": "ui_40ca5e357735",
  "Dev Mobile": "ui_9d8b14b0f9c5",
  "TECNOLOGIA": "ui_26646a40e585",
  "PESSOAS": "ui_86b0d73ffc0f",
  "IMPACTO": "ui_c691e7f8a3e7",
  "Histórias também são feitas de código": "ui_0820f46b55ce",
  "Histórias": "ui_961d1d02ccef",
  "Também são": "ui_09651c5ec893",
  "Feitas de código.": "ui_d7b2089e0300",
  "Mateus Cabral, Engenheiro de Software": "ui_5079787ffb66",
  "Transformando": "ui_ab9e6244b104",
  "ideias em": "ui_f15c023b8caf",
  "produtos reais,": "ui_e893207a0004",
  "do código ao": "ui_2d5550b1ca28",
  "impacto.": "ui_bab97ef8b28c",
  "Clientes e parceiros": "ui_79a6bddac3d0",
  "CLIENTES": "ui_f5d2cee52c04",
  "E PARCEIROS": "ui_a83ae4d35ab7",
  "Ações de contato": "ui_de6e191e42b0",
  "Currículo": "ui_eb40a4364013",
  "Contato direto": "ui_671a75ddb500",
  "Resposta rápida": "ui_5cf2eabe2f7e",
  "QR Code para abrir conversa com Mateus no WhatsApp": "ui_44c6a770922a",
  "Escaneie e fale comigo no WhatsApp": "ui_b555aeae48c9",
  "Aponte a câmera para o QR Code ou abra a conversa diretamente pelo botão abaixo.": "ui_e34c3cde9227",
  "Abrir conversa": "ui_a8bba40ab0e0",
  "Retrato de Mateus Cabral": "ui_c4e8adb146e9",
  "Abrir LinkedIn": "ui_5ae46873c10f",
  "Enviar email": "ui_69acc92448df",
  "Vamos Nessa?": "ui_b8c554506699",
  "Abrir conversa no WhatsApp": "ui_266cdde0a13b",
  "LET'S TALK": "ui_0d959c8e0469",
  "Bom dia!": "ui_e358708abb75",
  "Boa tarde!": "ui_3b0e88160c66",
  "Boa noite!": "ui_b14b7fd6297f",
  "CARREGANDO...": "ui_7946871d918f",
  "CARREGANDO CÉREBRO 3D...": "ui_0536f43ac938",
  "Projeto em destaque": "ui_d5d923d131de",
  "Ecossistema comercial": "ui_8db46b4873a7",
  "Experiência bancária mobile": "ui_5c607cd1f8c7",
  "Comércio digital internacional": "ui_6d56e333fadf",
  "Catálogo": "ui_dc7ababc44cc",
  "Agenda e recorrência": "ui_274361b2e7dc",
  "Comunidade editorial": "ui_e41b26be5fea",
  "Presença institucional": "ui_b088cd0a659f",
  "Marca e captação local": "ui_9289ebea6d1e",
  "Conversão": "ui_92f5342b1465",
  "SELECIONAR": "ui_8396f8dc3a73",
  "ATUAL": "ui_2fe4bf43c2bc",
  "Brasil": "ui_6641c5a7ff9f",
  "BRASIL": "ui_64513e16c2b6",
  "México": "ui_6f7fbf531956",
  "MÉXICO": "ui_1ba07fa8a85a",
  "Jalisco · Pacífico": "ui_995480e263f6",
  "Guiné-Bissau": "ui_f1f1d7cd8446",
  "GUINÉ-BISSAU": "ui_a37130fa4209",
  "África Ocidental": "ui_bfccce4e64ed",
  "Estados Unidos": "ui_20d1a5eb0b1a",
  "ESTADOS UNIDOS": "ui_150a1552e712",
  "Europa": "ui_fc30e2a579cd",
  "Preview do painel de gestão Nexovare": "ui_c69880c17af6",
  "Monograma NX do ecossistema Nexovare": "ui_6ece9b11844d",
  "Preview do projeto APP BANCO": "ui_5853bfa97f75",
  "Logo do projeto APP BANCO": "ui_1474c4adcc00",
  "Preview do marketplace Bideiras em Guiné-Bissau": "ui_7ebfb62d815d",
  "Ícone da Bideiras em forma de sacola nas cores da Guiné-Bissau": "ui_69555d6881d4",
  "Preview do projeto APP BARBEARIA": "ui_4f3fe799d2e3",
  "Logo do projeto APP BARBEARIA": "ui_6e85461bad14",
  "Página inicial do projeto Entre Paginas": "ui_740700a6e162",
  "Logo Entre Paginas": "ui_254a083d9fb6",
  "Preview do projeto Wagner Adv": "ui_94376b5771a5",
  "Logo do projeto Wagner Adv": "ui_ddff1c380e57",
  "Preview do projeto Fran Studio": "ui_c45c5e218447",
  "Logo do projeto Fran Studio": "ui_66f57b0509de",
  "Gestão completa de cotações, produtos e fornecedores para operações comerciais com visão clara do negócio.": "ui_f3c1d5dc152a",
  "Experiência bancária mobile desenhada para tornar consultas, movimentações e decisões financeiras mais simples.": "ui_d009efe65189",
  "Loja virtual com catálogo, carrinho e checkout para conectar produtos locais a clientes em Guiné-Bissau.": "ui_c3af7c07e708",
  "Agenda digital com recorrência, organização de serviços e uma jornada direta para clientes e profissionais.": "ui_f0d994ec334c",
  "Experiência editorial para um clube de leitura, com narrativas imersivas, encontros e descoberta de livros.": "ui_8403740932f8",
  "Presença institucional elegante, com conteúdo jurídico acessível e canais de contato fáceis de encontrar.": "ui_95671de85091",
  "Vitrine digital para serviços, identidade de marca e captação de clientes em uma experiência local acolhedora.": "ui_a3694ce49966",
  "Origem: Fortaleza, Brasil": "ui_3d43bbcce78e",
  "BRASIL · ORIGEM": "ui_9d9cb2a9b602",
  "· DESTINO": "ui_ac2f629fa1a4",
  "Selecionar {{name}}": "ui_9f897d097511",
  "Destino atual: {{city}}, {{country}}": "ui_74c87369a418",
  "País do projeto: {{country}}": "ui_658139845434",
  "Controles do mapa": "ui_7c10582e7b01",
  "Centralizar mapa": "ui_7bcadec57a4a",
  "Aumentar mapa": "ui_8a91f08e387b",
  "Diminuir mapa": "ui_262bb5fa788b",
  "Tecnologias": "ui_7e415e542701",
  "Todos os projetos": "ui_f21c564a3448",
  "Próximo projeto": "ui_daf7b29c62c9",
  "Índice de projetos": "ui_91573764eaa9",
  "Mapa dos projetos": "ui_4be397f614a1",
  "Paginação de projetos": "ui_0ca6a4901d15",
  "Projeto anterior": "ui_f354b7a7d88f",
  "Projeto em destaque: {{name}}": "ui_b40f9ee4082f",
  "Projeto em destaque do portfólio": "ui_e21ea0ee51ef",
  "Abrir projeto {{name}}": "ui_3b02b98aa791",
  "Tecnologias utilizadas no projeto {{name}}": "ui_498de94aa887",
  "O que foi recebido": "ui_06ab54132f33",
  "O que já é conhecido": "ui_57aefea837f7",
  "Busca de informações": "ui_cb46537856a2",
  "Comparação de caminhos": "ui_4582bf7abf18",
  "Resultados": "ui_31056106ce60",
  "ENTRADA": "ui_dda33024005f",
  "CONTEXTO": "ui_0435003324a9",
  "BUSCA": "ui_710ef6f2a335",
  "SAÍDA": "ui_192bfd3fb41c",
  "Intenção": "ui_c5b0d91ac7b7",
  "PEDIDO": "ui_3fcaf4d3daff",
  "Objetivo declarado que inicia a composição de contexto e define o resultado esperado.": "ui_088e70faf37b",
  "Documentos": "ui_22a3ce5a1659",
  "TEXTOS": "ui_aeff1299177b",
  "Fontes textuais autorizadas, organizadas para extração e associação semântica.": "ui_9bbd9d413fc8",
  "Código": "ui_f58b85570398",
  "CÓDIGO": "ui_fef2a9816c4e",
  "Estruturas, contratos e implementações que acrescentam evidência técnica ao contexto.": "ui_b662027d8656",
  "Preferências": "ui_6706dbe8b723",
  "PREFERÊNCIAS": "ui_f901102e67af",
  "Restrições de linguagem, apresentação e escopo aplicadas antes da síntese.": "ui_73eae347bc6f",
  "Contexto lembrado": "ui_cfe45c5bb7bf",
  "LEMBRAR": "ui_cb10645784f0",
  "Camada CAG que mantém contexto estável já preparado para reduzir reconstruções desnecessárias.": "ui_3799d17670fc",
  "Lembranças organizadas": "ui_a3503e6671d0",
  "MEMÓRIA": "ui_67aaebe90d7e",
  "Conhecimento resumido, revisado e mantido como contexto de longa duração.": "ui_cd24bf28149d",
  "Filtro de informações": "ui_950c3f6f5ad1",
  "FILTRO": "ui_dfd6401027c8",
  "Decide o que pode entrar no contexto público e o que deve permanecer fora da visualização.": "ui_98d10bedfdbb",
  "Centro de decisões": "ui_3d1bc4976f40",
  "CÉREBRO": "ui_159b4e956fb3",
  "Ponto de convergência entre contexto pré-carregado e recuperação orientada pela consulta.": "ui_d817f57457bf",
  "Busca combinada": "ui_2c8f9e3d416d",
  "BUSCAR": "ui_c149ec2f90b9",
  "Combina sinais semânticos e estruturados para localizar material relevante.": "ui_0ccb5a61744b",
  "Ordem de importância": "ui_de4f7a5325d6",
  "ORDEM": "ui_1b9ef0546dc2",
  "Ordena fragmentos pela relação com o objetivo, recência e força da evidência.": "ui_d1eebe9e1baa",
  "Evidências": "ui_841008249629",
  "EVIDÊNCIAS": "ui_5f5dfc72a596",
  "Trechos e relações selecionados para sustentar a resposta e permitir verificação.": "ui_51ac2c23d286",
  "Escolha de caminho": "ui_a900bab8d39c",
  "Seleciona a estratégia adequada para transformar o contexto em uma solução verificável.": "ui_97878d57864f",
  "Montagem da resposta": "ui_fcb405adfd17",
  "Integra contexto, evidências e objetivo em uma estrutura coerente de saída.": "ui_be7004617270",
  "Conferência final": "ui_89bc0280e188",
  "Compara resultado, requisitos e evidências antes de liberar uma resposta.": "ui_42d85f2fd018",
  "Implementações, testes e artefatos construídos a partir do contexto validado.": "ui_1297669e068b",
  "Pesquisa": "ui_589b48ed96e5",
  "Análises sustentadas por fontes e distinção clara entre evidência e inferência.": "ui_4d0dc6f8ea09",
  "Sistemas visuais e experiências que convertem intenção técnica em leitura humana.": "ui_e8c03f6d8cef",
  "Automação": "ui_0c177757203d",
  "Fluxos repetíveis com critérios explícitos, observação e limites de execução.": "ui_80238fc6150a",
  "Pensamento": "ui_80cf8e496855",
  "Veja ideias surgindo, sendo comparadas e escolhidas.": "ui_2a85bcfecfa3",
  "Como responde": "ui_9b63ab2d1c2a",
  "Acompanhe o caminho do pedido até a resposta final.": "ui_bc47d1c2178c",
  "Lembranças": "ui_d3247ce0038d",
  "Veja conhecimentos relacionados sendo encontrados e conectados.": "ui_bec0e7e34236",
  "Cérebro anatômico 3D com contornos luminosos nas fissuras corticais": "ui_4f3995ef9f90",
  "Visão": "ui_ecf7984e8ec7",
  "Memória": "ui_fcd95b14beda",
  "Raciocínio": "ui_c333eec8f6cc",
  "Percepção": "ui_556bde9c1381",
  "sinais": "ui_9db301fb5635",
  "amostras": "ui_7af27baaf512",
  "Mapa de atenção": "ui_2ad778f97612",
  "Distribuição dinâmica da atenção": "ui_599b68e1e2c7",
  "Ativação latente": "ui_88a08369bfa0",
  "Ativação por dimensão latente": "ui_e3f5125e2986",
  "DIMENSÃO LATENTE": "ui_77e6688a6554",
  "ATIVAÇÃO": "ui_76ef9d99280a",
  "Radar cognitivo": "ui_86845e33e23d",
  "Equilíbrio das capacidades cognitivas": "ui_40e75506f970",
  "Leituras cognitivas em transição contínua": "ui_dc166e2fe7cd",
  "ATIVIDADE DO CÉREBRO": "ui_cdc060c83521",
  "CAMINHO DA RESPOSTA": "ui_1b7350c98729",
  "LEMBRANÇAS ATIVAS": "ui_a3a4ee57874b",
  "ESCOLHENDO CAMINHOS": "ui_85ec86c01918",
  "JUNTANDO INFORMAÇÕES": "ui_b94eda8ec7d4",
  "BUSCANDO LEMBRANÇAS": "ui_9668d5f3a468",
  "ENTENDER": "ui_8e2a13b1039a",
  "PEDIDO RECEBIDO": "ui_6c628a59f0b3",
  "ENTENDIDO": "ui_7fbd97f2ec4f",
  "IMAGINAR": "ui_45d92a11aa7b",
  "CAMINHOS POSSÍVEIS": "ui_8263d98ab150",
  "12 IDEIAS": "ui_1d82e7dda222",
  "EXPERIÊNCIAS ÚTEIS": "ui_a93381b7d241",
  "48 LEMBRANÇAS": "ui_905c2846eab7",
  "COMPARAR": "ui_f63b14abc0c0",
  "MELHOR OPÇÃO": "ui_6b8a038d61da",
  "95% SEGURA": "ui_5db59babaee7",
  "DECIDIR": "ui_3a041167ccf9",
  "PRÓXIMA AÇÃO": "ui_d753cd48baec",
  "ESCOLHIDA": "ui_7520b9fb77d6",
  "LER": "ui_169da8b7a0e0",
  "PEDIDO E CONTEXTO": "ui_b92e106f4376",
  "6 PARTES": "ui_275b3bf10f1b",
  "INFORMAÇÕES ÚTEIS": "ui_7b9c62f0f41d",
  "31 ENCONTRADAS": "ui_1dfc83595efb",
  "SEPARAR": "ui_02c27164e0a6",
  "MELHORES FONTES": "ui_5fecc2898b11",
  "8 USADAS": "ui_dcecafe1b9cf",
  "JUNTAR": "ui_ff8378cdb94e",
  "INFORMAÇÕES": "ui_f73a4c0605bc",
  "PRONTO": "ui_e94552bc010e",
  "MONTAR": "ui_d63330f382aa",
  "RESPOSTA FINAL": "ui_350f859b11ff",
  "EM CURSO": "ui_6d479f73ad34",
  "PROCURAR": "ui_908b91da6955",
  "LEMBRANÇAS RELACIONADAS": "ui_77320302a936",
  "ENCONTRAR": "ui_0496acc05c3a",
  "CASOS PARECIDOS": "ui_8e3f1f077b03",
  "24 ITENS": "ui_02e8903b3fcc",
  "PRIORIZAR": "ui_c254b7f05ac8",
  "MAIS RECENTES": "ui_84fa6c95f4d1",
  "CONECTAR": "ui_56236c28f2da",
  "LEMBRANÇAS": "ui_00ddf5d4ed8c",
  "4 GRUPOS": "ui_8f957385a740",
  "DEVOLVER": "ui_a1b217a017b7",
  "CONTEXTO ÚTIL": "ui_3da5432c2cd4",
  "Cérebro artificial em funcionamento": "ui_bfd4961145dd",
  "CÉREBRO ARTIFICIAL EM ATIVIDADE": "ui_e1c3fd3ecbfe",
  "CICLO 24C": "ui_3942876b8228",
  "ETAPA 37": "ui_99273b1360bb",
  "NÍVEL DE ATIVAÇÃO": "ui_311489584839",
  "· PENSAMENTO ATUAL": "ui_aee3ff346cd1",
  "etapa": "ui_00ed591b5c5f",
  "de 5 ·": "ui_cb73e4aa2e4b",
  "// RACIOCÍNIO AGORA": "ui_09931b19f328",
  "PENSANDO ·": "ui_bdbb50de9955",
  "CÉREBRO IA": "ui_ec652ad8a225",
  "SIMULAÇÃO VISUAL DO CÉREBRO ARTIFICIAL": "ui_1b623ce14639",
  "Ir para o início": "ui_ef49e5940ae9",
  "Navegação principal mobile": "ui_65dec4a23c0c",
  "Fechar menu": "ui_7ff31408d36a",
  "Abrir menu": "ui_7db0b2e89b4c",
  "Mais contatos": "ui_4222d444e8ce",
  "Abrir chat": "ui_46cfb1f2220f",
  "Mensagem": "ui_322085898310",
  "Lag Arthur, assistente da Cabraiz": "ui_c18dedbcdd31",
  "Atendente": "ui_77c6a73723c3",
  "Jogo do elevador": "ui_f17e52a1c86e",
  "Elevator Control": "ui_a51cef9b6495",
  "Fechar jogo do elevador": "ui_651a507d8971",
  "Indicadores do elevador": "ui_b3835a4cea97",
  "Score": "ui_38e5a46cbc5a",
  "Entregas": "ui_9f818dbe915c",
  "Cabine": "ui_9921bcc6a678",
  "Energia": "ui_2ced24713ba0",
  "Prédio com andares": "ui_f4eceff0e0ef",
  "Painel de andares": "ui_c27e87cbfb5f",
  "Subir um andar": "ui_e25612e10cad",
  "Subir": "ui_b3aad4488f3a",
  "Descer um andar": "ui_61c21002de75",
  "Descer": "ui_12728297b3d1",
  "Abrir": "ui_a01a5fce396e",
  "Fechar": "ui_0f2bd88ef0ac",
  "Abrir portas": "ui_e6fd4dc6b45b",
  "Fechar portas": "ui_a4f876d1a103",
  "Adicionar nova chamada": "ui_e57393417c04",
  "Chamada": "ui_87bec0ba9053",
  "Reiniciar jogo do elevador": "ui_bb68fac8bde3",
  "Reiniciar": "ui_4d1e6caec772",
  "Sair do jogo do elevador": "ui_6f146be87bdc",
  "Sair": "ui_2d023dea2a9d",
  "{{count}} passageiros aguardando no {{floor}}º andar": "ui_db6ff88d3c75",
  "Ir para o {{floor}}º andar": "ui_954d1d782928",
  "Energia zerada. Segure o prédio e reinicie a operação.": "ui_b1e61e4c3021",
  "Portas abertas: entregando passageiros e embarcando quem está no andar.": "ui_a2c86799bb1e",
  "Abrindo portas.": "ui_93972aca03e8",
  "Fechando portas.": "ui_e72e2f051026",
  "Escolha o destino mais próximo para manter sequência de entrega.": "ui_503dac8d6319",
  "Há chamadas ativas. Toque em um andar com ponto vermelho.": "ui_62e384cfbcc8",
  "Prédio sob controle. Aguarde a próxima chamada.": "ui_3628236d58c7",
  "Iniciando Drive": "ui_89488609cc98",
  "Falha ao carregar Drive": "ui_d5f7d977c99d",
  "Motor/base": "ui_4610816b31aa",
  "triângulos": "ui_3fcdc74207a8",
  "geometrias": "ui_74d095fefb10",
  "texturas": "ui_bbea171b2cb1",
  "Carros": "ui_de9effe76620",
  "player": "ui_cdb59355f3ba",
  "andando": "ui_23063a6b2c59",
  "IA cheia": "ui_c908382fff16",
  "renderizados": "ui_ab258f219804",
  "parados": "ui_44505a600f75",
  "danificados": "ui_8add88595bad",
  "Pedestres": "ui_c2c73c888be0",
  "agentes": "ui_82da49ee984b",
  "zonas": "ui_1f93bd7e094e",
  "colisão lock": "ui_8380ef96b7be",
  "travessia": "ui_889cd0f8e89c",
  "Prédios": "ui_866b6d81abc2",
  "bases": "ui_98979371e0cd",
  "buracos": "ui_71026cbd9492",
  "pedregulhos": "ui_68d158a0c13c",
  "Diagnóstico HomeDrive": "ui_ecf3cc094f1e",
  "coletando primeiros dados…": "ui_0483e934144c",
  "Peso atual do frame": "ui_4df596bc9d12",
  "barra 100% · carros · pedestres · prédios": "ui_50a41b509c8a",
  "Distribuição de custo do frame entre carros, pedestres e prédios": "ui_8fbb27ee055e",
  "Maior score de pressão no frame atual.": "ui_1c5119e43aa6",
  "Carros andando": "ui_de710d0d79ec",
  "Carros parados": "ui_bc9b341ac789",
  "Check-in na orla da Beira Mar.": "ui_59ba6f4e300c",
  "Check-in cultural no Dragão do Mar.": "ui_4a37b7f4f7ef",
  "Check-in no polo de eventos.": "ui_8016bfe8a627",
  "Check-in no entorno da Arena Castelão.": "ui_44263d2a1496",
  "Noitada na Aldeota": "ui_00f02f290f5a",
  "Check-in noturno na Aldeota.": "ui_5c3aae1ae4f9",
  "Check-in na saída leste/litoral rumo ao Beach Park.": "ui_1e1b65fe46b8",
  "Assets preparados.": "ui_fc7c200d9060",
  "Carregando imagens": "ui_111546e99c21",
  "Cockpit, volante e imagens de missão.": "ui_024e5e35bff5",
  "Imagens preparadas.": "ui_6dc6f641004f",
  "Imagens preparadas": "ui_6c0be6bac8e6",
  "Carregando sons": "ui_740d906cd91a",
  "Motor e camadas de aceleração.": "ui_a4182340d211",
  "Sons preparados.": "ui_60d4cc257bb8",
  "Sons preparados": "ui_04d0fff75b5a",
  "Montando prédios": "ui_c047c8f1ce33",
  "Gerando a cidade antes do primeiro frame.": "ui_4fc5474bfa05",
  "Cidade montada.": "ui_be91dc029e41",
  "Preparando carros": "ui_ecdbcea12a2b",
  "Tráfego dinâmico e carros estacionados.": "ui_ebe9c8880f66",
  "Trânsito pronto.": "ui_1ab4230192b3",
  "Preparando cidade": "ui_ea0e5bb67dd9",
  "Faixas, semáforos, postes e colisões.": "ui_17807a005257",
  "Ruas prontas.": "ui_bc200f36599e",
  "Preparando pessoas": "ui_ab55502f5808",
  "Animações, população e resident pool.": "ui_832103292caf",
  "Pessoas prontas.": "ui_3756001118b8",
  "Finalizando dados": "ui_ca4b500df27b",
  "Cidade, carros e pessoas prontos para instanciar.": "ui_1a6aa2abddaf",
  "Dados prontos": "ui_9af3fd9b6504",
  "Instanciando primeiro frame do mundo.": "ui_3ade0ef068e6",
  "Preparando carregamento completo.": "ui_d98dce010e33",
  "Aperte nada. O Drive está acordando.": "ui_1938d120e906",
  "Preparando o painel e a tela.": "ui_ffecf5401e48",
  "Aquecendo o motor.": "ui_a16198b9b4ee",
  "Montando a cidade.": "ui_502741cc5daf",
  "Colocando o trânsito na pista.": "ui_996831c180b0",
  "Acendendo ruas e cruzamentos.": "ui_2078defd5fb3",
  "Posicionando pessoas e animações.": "ui_9de66b44d662",
  "Travando tudo antes do primeiro frame.": "ui_de5aff686a02",
  "Esperando o mundo aparecer de verdade.": "ui_22531c6f6587",
  "Drive pronto.": "ui_19961df6be74",
  "Não foi possível carregar o Drive.": "ui_5f8eede5f3a1",
  "LOAD ERROR": "ui_ccfc6f615b97",
  "Etapas do carregamento": "ui_02d928804511",
  "Renderizando cidade": "ui_60581e2adfd1",
  "Aguardando o primeiro frame real antes de liberar.": "ui_7fa91f83ea42",
  "Velocímetro analógico: {{speed}} quilômetros por hora": "ui_21751ce73a13",
  "Volante": "ui_d6eebb70eaf9",
  "IMG": "ui_d083ab0535d6",
  "SOM": "ui_c046eafa1d26",
  "CID": "ui_6b632decb6d9",
  "CAR": "ui_1c0d3a3a646a",
  "RUA": "ui_9de32d552a28",
  "LOADING": "ui_ba0eebf37956",
  "NO CLICK": "ui_db762a76387a",
  "WAIT": "ui_4f618185f2ea",
  "RELOAD": "ui_8229c4ee6826",
  "POC!": "ui_06eca9d47436",
  "Encostou bonito.": "ui_329f4e801015",
  "Parede: 1 x 0.": "ui_b4c572913638",
  "Foi só um carinho.": "ui_8e4102a52451",
  "GPS recalculando.": "ui_faac334fc0a7",
  "Não era drive-thru.": "ui_af52f53e075f",
  "Fachada invicta.": "ui_37ac9f13bfac",
  "Airbag moral ativado.": "ui_b81c1c1e15dc",
  "O prédio nem piscou.": "ui_2c130a9ab722",
  "Manobra conceitual.": "ui_dbbe4f4f8f98",
  "MERMÃO!": "ui_def9539140f0",
  "A parede venceu.": "ui_6f2154e584f1",
  "Sinistro arquitetônico.": "ui_6491b70b430a",
  "Seguro chorando.": "ui_01c230aae71e",
  "Check-in no concreto.": "ui_7a4c56c7fe89",
  "Isso era uma fachada.": "ui_04e0f026b4dc",
  "Entrada negada.": "ui_287ee2df6acd",
  "Recepção fechada.": "ui_550b687a479a",
  "Portaria surpresa.": "ui_dbecfdd0e153",
  "Fundos invadidos.": "ui_55b613d9675e",
  "Saída era do outro lado.": "ui_ff87bbdc1f7b",
  "Beco errado.": "ui_8625793bf3b5",
  "Lateral sentiu.": "ui_ee2f632e572b",
  "Raspou com estilo.": "ui_32cdb2345cd9",
  "Curva otimista.": "ui_1cef58ff74b3",
  "Direita sem preferência.": "ui_2e9b7467049f",
  "Calçada discordou.": "ui_5723a9498e46",
  "Quase passou.": "ui_f045bca0f048",
  "Landing page": "ui_615e54d4d3a0",
  "Landing page mobile": "ui_efcb6bd6702f",
  "Back-End & APIs": "ui_61d62876dd32",
  "FLASH MODE": "ui_d20167bfac93",
  "ORDENAR": "ui_6faa97ece519",
  "PROVAS": "ui_e2ed93cf81c4",
  "ESCOLHER": "ui_7796edcf5e21",
  "CONFERIR": "ui_144ad075b7b0",
  "CRIAR": "ui_3a85935a098c",
  "PESQUISAR": "ui_16b5bbc1782e",
  "DESENHAR": "ui_616558c2ba00",
  "AUTOMATIZAR": "ui_ba6678dd8620",
  "Texto": "ui_6df3d6661c09",
  "Outros": "ui_e6031e8fb508",
  "Criatividade": "ui_72c7ee23c9bc",
  "Estabilidade": "ui_58d23d1ed283",
  "Bússola: direção {{direction}}. Destino {{name}}, {{distance}}.": "ui_9cbcb6872e74",
  "Bússola: direção {{direction}}": "ui_15ddadbfc2fe",
  "Norte": "ui_6f9f01a63d42",
  "Sul": "ui_e65f1d03a763",
  "Leste": "ui_6ef245e96f26",
  "Oeste": "ui_7000924adcfc",
  "Nordeste": "ui_804de1b2f0b9",
  "Noroeste": "ui_15250d8dc8ef",
  "Sudeste": "ui_e25282d7bf8a",
  "Sudoeste": "ui_2067a5418bb2",
  "Não foi possível carregar os dados.": "ui_351069b20228",
  "Carregando página": "ui_7cd8b767f307",
  "Carregando portfólio": "ui_7dafb472b353",
  "NÃO ERA": "ui_e6224d9d2bc8",
  "{{label}}: {{percent}}%": "ui_8171ad561c51",
  "AGUARDA": "ui_df2ce508d81e",
  "LLMs, RAG e Agentes": "ui_60ddc2f8bc04",
  "Engenheiro": "ui_f255a1926dc4",
  "IA & Full Stack": "ui_2c69b92312ee",
  "VAMOS CONVERSAR": "ui_101d3a89e717",
  "E-MAIL": "ui_04515fc99cbd",
  "Enviar e-mail para Mateus": "ui_aa3ce70443cd",
  "Idioma": "ui_7ae9d418353b",
  "Navegação lateral por seções": "ui_f51969d5f42a",
  "Senior AI Engineer": "ui_bcec9132332c",
  "Mateus Cabral, Senior AI Engineer": "ui_291bfa359bf2",
  "AI Engineer": "ui_ace51a8119a5",
  "Senior": "ui_92613a8f4340",
  "Remoto · CLT ou PJ": "ui_b3c10e7cda15",
  "AGENDAR CONVERSA": "ui_3901571f8940",
  "Região Centro": "ui_90c8664a3f6a"
}
